import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ariaLabel'
})
export class AriaLabelPipe implements PipeTransform {
  transform(value: string): string {
    const prefix = 'aria.';

    if (typeof value !== 'string' || !value) {
      return '';
    }

    if (value.startsWith(prefix)) {
      return value;
    }

    if (value.startsWith('lbl.')) {
      value = value.slice('lbl.'.length);
    }

    return prefix + value;
  }
}
